import { useEffect, useState } from "react";
import { getBirthdays } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

const Birthday = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const birthdayData = await getBirthdays();

        // Make sure API response is always treated as an array
        if (Array.isArray(birthdayData)) {
          setData(birthdayData);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching birthday data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const emptyArray = [
    { id: 1 },
    { id: 2 },
  ];

  const settings = {
    autoplay: true,
    infinite: data.length > 1,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const displayData = data.length > 0 ? data : emptyArray;

  return (
    <div className="row">
      <Slider {...settings}>
        {displayData.map((item, index) => {
          const hasImage =
            Array.isArray(item.attachments) &&
            item.attachments.length > 0;

          const imageUrl = hasImage
            ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com?url=${item.attachments[0]}`
            : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg";

          return (
            <div className="item" key={item._id || item.id || index}>
              <div className="topperdiv birthday">

                {/* Birthday Cake */}
                <div className="star">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/cake.png"
                      className="img-fluid"
                      alt="Birthday Cake"
                    />
                  </LazyLoad>
                </div>

                {/* Student Image */}
                <div className="toppertaj">
                  <LazyLoad
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg"
                        className="img-fluid"
                        alt="Loading"
                      />
                    }
                  >
                    <img
                      src={imageUrl}
                      className="img-fluid"
                      alt={item.name || "Student"}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg";
                      }}
                    />
                  </LazyLoad>
                </div>

                {/* Student Details */}
                <div className="topperdesc">
                  <p className="name">
                    {item.name || "Student Name"}
                  </p>

                  <p className="per">
                    {item.class || "Class"}
                  </p>
                </div>

              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Birthday;
